<app-review-wrapper title="Recipients" [complete]="groupSummary !== 'no groups'" (onEdit)="navigateToUrl()">
  <p class="rs__lead" aria-live="polite">
    @if (audience.loading && audience.count === null) {
      Counting recipients…
    } @else if (audience.count !== null) {
      Goes to
      <strong [class.is-bad]="audience.count === 0">
        {{ formatCount(audience.count) }} unique {{ audience.count === 1 ? "person" : "people" }}
      </strong>
      in {{ groupSummary }}.
    } @else {
      Goes to everyone in {{ groupSummary }}.
    }
  </p>

  <dl class="bk-kv rs__kv">
    @if (recipients.organizations.length > 0) {
      <dt>Organizations</dt>
      <dd>
        <span class="rs__chips">
          @for (item of recipients.organizations; track $index) {
            <span class="bk-chip">{{ item.name }}</span>
          }
        </span>
      </dd>
    }
    @if (recipients.tags.length > 0) {
      <dt>Tags</dt>
      <dd>
        <span class="rs__chips">
          @for (item of recipients.tags; track $index) {
            <span class="bk-chip">{{ item.name }}</span>
          }
        </span>
      </dd>
    }
    @if (recipients.segments.length > 0) {
      <dt>Segments</dt>
      <dd>
        <span class="rs__chips">
          @for (item of recipients.segments; track $index) {
            <span class="bk-chip">{{ item.name }}</span>
          }
        </span>
      </dd>
    }
  </dl>
</app-review-wrapper>
